<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'samplemanage-sampleTagPrint',
  components: {
    PageTable
  }
}
</script>
